import "./Refer.css";
import box from "../../../../../assets/box2.png";
import cancel from "../../../../../assets/cancel.png";

const Modal = ({ setReferModal, setShareModal }) => {
 return (
  <div className="refer-modal">
   <div className="overlay"></div>
   <div className="modal-box desktop">
    <div className="header">
     <p className="title"> Refer a friend</p>
     <p
      className="close-modal"
      onClick={() => {
       setReferModal(false);
      }}
     >
      <img src={cancel} alt="cancel" />
     </p>
    </div>
    <div className="image-container">
     <div>
      <img src={box} alt="box" />
     </div>
     <p className="title">Get free N1,000</p>
     <p className="desc">
      Earn cash reward when your friend signs up and become an affiliate with
      your referral code or link.
     </p>
    </div>

    <div className="link-container">
     <div>
      <p>Share</p>
      <p>
       <span
        className="share"
        onClick={() => {
         setReferModal(false);
         setShareModal(true);
        }}
       >
        Share Link
       </span>
      </p>
     </div>
     <div className="modal-custom-input">
      <input type="text" defaultValue="https://shap.com/legacy12" />
      <div className="copy-shapBtn">Copy</div>
     </div>
    </div>
   </div>
   <div className="modal-box mobile">
    <div className="header">
     <p className="title"> Refer a friend</p>
     <p
      className="close-modal"
      onClick={() => {
       setReferModal(false);
      }}
     >
      <img src={cancel} alt="cancel" />
     </p>
    </div>
    <div className="image-container">
     <div>
      <img src={box} alt="" />
     </div>
     <p className="title">Get free N1,000</p>
     <p className="desc">
      Earn cash reward when your friend signs up and become an affiliate with
      your referral code or link.
     </p>
    </div>

    <div className="link-container">
     <div>
      <p>Share</p>
      <p>
       <span
        className="share"
        onClick={() => {
         setReferModal(false);
         setShareModal(true);
        }}
       >
        Share Link
       </span>
      </p>
     </div>
     <div className="modal-custom-input">
      <input type="text" defaultValue="https://shap.com/legacy12" />
      <div className="copy-shapBtn">Copy</div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default Modal;
